import React from 'react';
import { Card, Radio, Tag } from 'antd';
import { Price } from '../Price';
const CardPriceInfo = props => {
    const { option, lineItem, isDarkMode, isSelected } = props;
    return (React.createElement("div", { className: "flex flex-col items-end text-right" },
        React.createElement("span", { className: "text-[13px]", style: { color: isDarkMode ? '#cccccc' : '#999999cc' } },
            React.createElement(Price, { value: option?.unit_price }),
            " ea."),
        React.createElement("span", { className: "text-[18px] font-bold", style: {
                color: isSelected ? '#C00' : isDarkMode ? '#fff' : '#1a1a1a',
            } },
            React.createElement(Price, { value: option?.total_price }))));
};
export const LeadTimeOptionCard = props => {
    const { option, readonly, lineItem, isDisabled, loading = false, isSelected = false, showFocdBadge = false, } = props;
    const isDarkMode = localStorage.getItem('dark-mode') === 'yes';
    const hasFocd = showFocdBadge && option?.focd_discount_pct != null && option.focd_discount_pct > 0;
    const cardBodyHeightPx = hasFocd ? 106 : 80;
    return (React.createElement(Card, { key: option?.id, bodyStyle: {
            padding: '5px',
            height: `${cardBodyHeightPx}px`,
            position: 'relative',
        }, style: {
            width: '100%',
            maxWidth: '240px',
            marginBottom: '12px',
            marginRight: '12px',
            border: isSelected ? '2px solid #2094f3' : '1px solid #e5e7eb',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            transition: 'all 0.2s ease',
            cursor: !readonly ? 'pointer' : 'default',
            backgroundColor: isDisabled
                ? isDarkMode
                    ? '#222'
                    : '#f5f5f5'
                : !readonly && isSelected
                    ? isDarkMode
                        ? '#333'
                        : '#f8fbff'
                    : isDarkMode
                        ? '#1a1a1a'
                        : '#ffffff',
            color: isDarkMode ? '#fff' : '#000',
            opacity: isDisabled ? 0.5 : 1,
        }, loading: loading },
        React.createElement("div", { className: "flex flex-row justify-between w-full h-full" },
            readonly ? (React.createElement("div", { className: "flex flex-col justify-between w-full h-full" },
                React.createElement("div", { className: "flex flex-row justify-between w-full h-full" },
                    React.createElement("span", { className: "p-2 " },
                        option?.lead_time,
                        " Business Days"),
                    React.createElement(CardPriceInfo, { option: option, lineItem: lineItem, isDarkMode: isDarkMode, isSelected: isSelected })))) : (React.createElement(Radio, { value: option?.id, className: "m-0 !w-full p-0", style: { height: '100%' } },
                React.createElement("div", { className: "flex flex-row justify-between leadtime-radio-content", style: { height: '100%' } },
                    React.createElement("span", { className: "flex !flex-wrap !whitespace-nowrap !text-wrap !break-words" },
                        option?.lead_time,
                        " Business Days"),
                    React.createElement("div", { className: "flex justify-end ml-2" },
                        React.createElement(CardPriceInfo, { option: option, lineItem: lineItem, isDarkMode: isDarkMode, isSelected: isSelected }))))),
            hasFocd && (React.createElement("div", { style: {
                    position: 'absolute',
                    bottom: '1.8rem',
                    left: '0.5rem',
                } },
                React.createElement(Tag, { color: "green", style: { fontSize: 10, lineHeight: '16px', padding: '0 5px', margin: 0 } }, "First Order Discount"))),
            option?.type === 'Expedited' ? (React.createElement("div", { style: {
                    position: 'absolute',
                    bottom: '0.5rem',
                    left: '0.5rem', // same as Tailwind's left-2
                }, className: "absolute bottom-2 left-2 bg-blue-500 text-white text-xs px-2 py-0.5 rounded-full" }, "Expedited")) : (React.createElement("div", { style: {
                    position: 'absolute',
                    bottom: '0.5rem',
                    left: '0.5rem', // same as Tailwind's left-2
                }, className: "absolute bottom-2 left-2 bg-green-600 text-white text-xs px-2 py-0.5 rounded-full" }, "Standard")))));
};
